// extracted by mini-css-extract-plugin
module.exports = {"banner":"_3Jj4XL","shine-lines":"_2jxVPF"};